import { render, staticRenderFns } from "./StepForm.vue?vue&type=template&id=6bf2a94e&scoped=true"
import script from "./StepForm.vue?vue&type=script&lang=js"
export * from "./StepForm.vue?vue&type=script&lang=js"
import style0 from "./StepForm.vue?vue&type=style&index=0&id=6bf2a94e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf2a94e",
  null
  
)

export default component.exports